// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"deb4fe25","446":"deb4fe25"}[chunkId] + ".chunk.css";
};